import React, { useState } from 'react';
import { Row, Col, Divider } from 'antd';
import { useHistory } from 'react-router-dom';

import { useLibertyMutualSubStepsContext } from '../context';
import { ReportInformation } from './ReportInformation';
import { Text, Title } from '@/components/Typography';
import { ResultsContainer } from './styles';
import { DownloadPDF } from './DownloadPDF';
import { Summary } from './Summary';
import { Header } from './Header';
import { SendReportModal } from '@/components/ui/Modals/SendReportModal';
import { useApplicationContext } from '@/context/v1/Application/context';
import { SendReportButton } from '@/components/ui/Buttons/SendReportButton';
import { SendReportModalProps, Report } from '@/components/ui/Modals/SendReportModal/types';
import type { SendReportRequest } from '@/types/Sandbox';

export function Result() {
	const history = useHistory();
	const [isEditing, setIsEditing] = useState<boolean>(false);
	const [isSendReportModalOpen, setIsSendReportModalOpen] = useState<boolean>(false);
	const { libertyMutualResult, useExistsReport, file_id, liberty_mutual_report_id } = useLibertyMutualSubStepsContext();
	const { organization, company, isSandbox, sendReport } = useApplicationContext()

	const { exists } = useExistsReport(isSandbox, file_id, company?.id, organization?.id)

	if (!libertyMutualResult?.id) {
		return (
			<Row justify="center">
				<Col>
					<Text>Oops... Something went wrong!</Text>
				</Col>
			</Row>
		);
	}

	function handleDisableFormEdition(editing: boolean) {
		setIsEditing(editing);
	}

	function handleSendReport(): void {
		const request: SendReportRequest = {
			report_type: 'LIBERTY_MUTUAL',
			id: liberty_mutual_report_id || '',
			company_id: company?.id,
			organization_id: organization?.id
		};
		setIsSendReportModalOpen(false);
		sendReport(request, '/reporting');

		const currentPath = history.location.pathname;
		const cleanPath = currentPath.match(/(\/reporting\/liberty-mutual)/)?.[1];

		if (cleanPath && currentPath !== cleanPath) {
			history.replace(cleanPath);
		}
	}

	function mountSendReportModalProps(): SendReportModalProps {
		const report: Report = {
			id: libertyMutualResult.id || '',
			workstation_name: libertyMutualResult.informations.workstation_name,
			tools_to_show: [],
			action_plans: [],
			files_names: [libertyMutualResult.informations.original_name]
		};
		return {
			isOpen: isSendReportModalOpen,
			onCancel: () => setIsSendReportModalOpen(false),
			onConfirm: handleSendReport,
			report: report,
			exists: exists
		};
	}

	return (
		<Row justify="center">
			<Col span={24} style={{ marginBottom: '2rem', padding: '0 1rem', display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
				<Title level={4}>Result</Title>
				{isSandbox && <SendReportButton onClick={() => setIsSendReportModalOpen(true)} />}
			</Col>
			<Col style={{ padding: '1rem' }}>
				<ResultsContainer>
					<Header />
					<ReportInformation />
					<Divider type="horizontal" />
					<Summary />
					<Divider type="horizontal" />
					<DownloadPDF onDownloadPDF={handleDisableFormEdition} disableDownload={isEditing} />
				</ResultsContainer>
			</Col>
			{isSandbox && <SendReportModal {...mountSendReportModalProps()} />}
		</Row>
	);
}
